import script from "./HomepageUnicefbelgiqueSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepageUnicefbelgiqueSlider.vue?vue&type=script&setup=true&lang=js"

import "./HomepageUnicefbelgiqueSlider.vue?vue&type=style&index=0&id=4615d3b2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4615d3b2"]])

export default __exports__